module.exports = __webpack_public_path__ + "img/img11.afb9d92c.svg";